import { useEffect, useState } from "react"

export const secondsUntil =(expiresAt) => (expiresAt ? Math.max(0, Math.ceil((new Date(expiresAt).getTime() - Date.now()) / 1000)) : 0)

// Seconds left until an ISO timestamp, ticking once a second; 0 once it has passed (or is unset).
export const useExpiryCountdown = (expiresAt) => {
  const [secondsLeft, setSecondsLeft] = useState(() => secondsUntil(expiresAt))

  useEffect(() => {
    setSecondsLeft(secondsUntil(expiresAt))
    if (!expiresAt) return undefined
    const timer = setInterval(() => {
      const remaining = secondsUntil(expiresAt)
      setSecondsLeft(remaining)
      if (remaining === 0) clearInterval(timer)
    }, 1000)
    return () => clearInterval(timer)
  }, [expiresAt])

  return secondsLeft
}

export const formatCountdown = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`
